import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { goBack, CallHistoryMethodAction } from 'connected-react-router';

import BackIcon from '@components/basics/icons/back';
import Typography from '@components/basics/typography';
import DashboardContainer from '@components/layout/dashboard-container';
import Tos from '@components/statics/terms-of-service';
import styled from 'styled-components';
import AppState from '@webapp/store/state';

interface TermsOfServicePageProps {
  className?: string;
  goBack: () => CallHistoryMethodAction;
  isMobile: boolean;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goBack: () => dispatch(goBack()),
});

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const TermsOfServicePage: React.FC<TermsOfServicePageProps> = (props) => (
  <DashboardContainer className={props.className}>
    <Row isMobile={props.isMobile}>
      <BackIcon className="mb-50" onClick={() => props.goBack()} />
      <EmptyDiv>
        <Flex>
          <Wrapper isMobile={props.isMobile}>
            <TextDiv>
              <Typography className="mb-30" type="subheader" weight="700">
                Terms of Service
              </Typography>
              <Typography className="mb-30 grayColor" weight="400">
                Updated on: 11 May 2022
              </Typography>
            </TextDiv>
            <PrivacyWrapper>
              <Tos />
            </PrivacyWrapper>
          </Wrapper>
        </Flex>
      </EmptyDiv>
    </Row>
  </DashboardContainer>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(TermsOfServicePage)`
  .grayColor {
    color: ${({ theme }) => theme.colors.privacyPolicyLastUpdated};
  }
`);

const Row = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
`;

const Wrapper = styled.div<{ isMobile: boolean }>`
  width: 50%;
  width: ${({ isMobile }) => (isMobile ? '100%' : '50%')};
`;
const EmptyDiv = styled.div`
  margin-top: 10px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
`;

const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PrivacyWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.privacyPolicyBackground};
  padding: 30px;
  border-radius: 10px;
`;
